<template>
  <div class="container-wrap">
    <div class="tips">
      开启审批后，满足审批条件的类型，由审批人同意后操作方可生效。
    </div>
    <el-table
      class="mwow-table"
      size="mini"
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="业务类型" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">购买</span>
          <span v-if="scope.row.type === 2">退款</span>
          <span v-if="scope.row.type === 3">转课</span>
        </template>
      </el-table-column>
      <el-table-column label="审批开关" prop="status">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleChangeStatus(scope.row)"
            v-if="!(isOnlinePay && scope.row.type === 2)"
          ></el-switch>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="审批类别" prop="mode">
        <template slot-scope="scope">
          <span v-if="scope.row.mode === 1">会签</span>
          <span v-if="scope.row.mode === 2">或签</span>
        </template>
      </el-table-column>
      <el-table-column label="审批条件" prop="condition">
        <template slot-scope="scope">
          <p v-if="scope.row.condition === 1">
            <span>无限制</span
            ><span style="color: #9e9fa0">（此类操作全部需要审批）</span>
          </p>
          <div v-else>
            <p>
              <span>特定条件</span
              ><span style="color: #9e9fa0">（满足其中一项即需要审批）</span>
            </p>
            <p
              v-for="item in scope.row.condition_item_list"
              :key="item.item_key"
            >
              <span v-if="item.item_value"
                >—— {{ itemKeyTranslate(item.item_key) }} ≥
                {{ item.item_value }}；</span
              >
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="审批人">
        <template slot-scope="scope">
          {{
            scope.row.staff_list
              .map((item) => {
                return item.name;
              })
              .join("、")
          }}
          <span v-if="scope.row.staff_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="抄送人">
        <template slot-scope="scope">
          {{
            scope.row.copy_staff_list
              .map((item) => {
                return item.name;
              })
              .join("、")
          }}
          <span v-if="scope.row.copy_staff_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div class="table-btns">
            <edit-dialog
              :origin-data="scope.row"
              :online-pay="isOnlinePay"
              @change="getList"
            >
              <div class="mwow-button success">编辑</div>
            </edit-dialog>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { approvalRuleListApi, approvalRuleStatusEditApi } from "@/api/approve";
import editDialog from "./editDialog.vue";
export default {
  props: ["visible"],
  name: "approvalRule",
  components: {
    editDialog,
  },
  data() {
    return {
      tableData: [],
      isOnlinePay: false,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList();
    }
  },
  methods: {
    itemKeyTranslate(v) {
      switch (v) {
        case "order_give_class":
          return "赠送课时";
        case "order_discount_amount":
          return "直减金额";
        case "order_refund_amount":
          return "退款金额";
      }
    },

    getList() {
      approvalRuleListApi().then((res) => {
        res.data.list.map((item) => {
          item.status = item.status === 1;
        });
        this.isOnlinePay = res.data.online_pay;
        this.tableData = res.data.list;
      });
    },
    handleChangeStatus(row) {
      if (row.status && row.staff_list.length === 0) {
        this.$message({
          type: "warning",
          message: "请设置审批人",
        });
        this.getList();
        return false;
      }
      approvalRuleStatusEditApi({
        type: row.type,
        status: row.status ? 1 : 2,
      })
        .then(() => {
          this.getList();
        })
        .catch(() => {
          this.getList();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-wrap {
  padding: 12px;
}
.tips {
  height: 28px;
  line-height: 28px;
  background: #fff7e9;
  border-radius: 4px;
  font-size: 12px;
  color: #5c5d5e;
  padding: 0 6px;
  display: inline-block;
  margin-bottom: 12px;
}
</style>
